module.exports = __webpack_public_path__ + "img/oufu_80x110x8_5b.prt.c404430c.jpg";